import React from 'react';

// "NOTHING HERE" IN A TABLE CELL, said the same way everywhere.
//
// #9ca3af is the palette's placeholder grey — what STYLE.md gives for empty states — and the reason this
// is a component rather than an inline style repeated in every cell is that the wrong colour here reads
// as a problem. A vendor created a minute ago with no bindings, no grants and no users had all three
// rendered in warning amber, which made a new record look like a broken one.
//
// For something that genuinely needs attention, use a Badge, not this.
const EmptyValue = ({ children = '—' }) => (
    <span style={{ color: '#9ca3af' }}>{children}</span>
);

export default EmptyValue;
